export default "__VITE_ASSET__BVAsGPT9__"